export const ROWS_PER_PAGE_ITEMS = [5, 10, 15, 25];

export const ROWS_PER_PAGE_TEXT = "Anzahl der Reihen pro Seite";

export const TABLE_LOADING_TEXT = "Daten werden geladen...";

